import { render, staticRenderFns } from "./ResultCards.vue?vue&type=template&id=25db3730&"
import script from "./ResultCards.vue?vue&type=script&lang=js&"
export * from "./ResultCards.vue?vue&type=script&lang=js&"
import style0 from "./ResultCards.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports